<template>
  <h3 class="title">
    <button :class="buttonClasses"></button>
    <span class="text">
      <slot></slot>
    </span>
  </h3>
</template>

<script>
export default {
  name: 'Title',
  props: {
    closed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonClasses () {
      return {
        'button': true,
        'button-closed': this.closed
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  cursor: pointer;
  padding: 20px;
  margin: 0;
  font-size: $fs-bread;
  line-height: $lh-bread;
  font-weight: $fw-bold;
}

.text {
  display: block;
  margin-left: 40px;
}

.button {
  float: left;
  font-size: $fs-bread;
  width: 40px;
  background-color: transparent;
  border: none;
  outline: 0;
  cursor: pointer;
  position: relative;
  margin-top: 25px;

  &::before,
  &::after {
    content: '';
    position: absolute;
    left: 0;
    width: 22px;
    border-bottom: 3px solid white;
    border-radius: 1px;
  }

  &::after {
    transform: rotate(0deg);
  }
}

.button-closed::after {
  transform: rotate(90deg);
}
</style>
